import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import AddressPicker from '../../SharedComponents/Forms/AddressPicker';

const { Option } = Select;

export type AddressType = {
  lng: string;
  lat: string;
  address: string;
};

type LocationSelectorProps = {
  label: React.ReactNode;
  value: string | AddressType | null;
  locations: { key: string; name: string }[];
  onChange: (value: string | AddressType | null) => void;
};

const LocationSelector: React.FC<LocationSelectorProps> = ({ label, value, locations, onChange }) => {
  const [mode, setMode] = useState<'select' | 'custom'>(value && value !== '__custom__' ? 'select' : 'custom');
  const [customAddress, setCustomAddress] = useState<AddressType | null>(
    value && typeof value !== 'string' ? value : null,
  );

  // Reset internal states if value is null or cleared
  useEffect(() => {
    if (value === null) {
      setMode('select');
      setCustomAddress(null);
    }
  }, [value]);

  return (
    <div>
      <label htmlFor="selectId" className="fw-600">
        {label}
      </label>
      {mode === 'select' ? (
        <Select
          value={value ?? undefined}
          className="w-100"
          placeholder="Select"
          onChange={(val) => {
            if (val === '__custom__') {
              setMode('custom');
              onChange(null);
            } else {
              onChange(val);
            }
          }}
          allowClear
        >
          {locations.map((loc) => (
            <Option key={loc.key} value={loc.key}>
              {loc.name}
            </Option>
          ))}
          <Option value="__custom__">Custom Address...</Option>
        </Select>
      ) : (
        <div className="mg-t-8">
          <AddressPicker
            value={customAddress ? customAddress.address : ''}
            onChange={(val) => {
              setCustomAddress(val);
              onChange(val);
            }}
          />
          <button
            type="button"
            className="d-block mg-t-4 fs-12 c-blue cursor-pointer bg-none bd-none pd-0"
            onClick={() => {
              setMode('select');
              onChange(null);
            }}
          >
            Choose from saved locations
          </button>
        </div>
      )}
    </div>
  );
};

export default LocationSelector;
